<template>
    <v-select :items="items" item-text="name" item-value="site" placeholder="Family Site" hide-details="auto" height="40" outlined class="rounded-pill" @change="handleSelectChange" />
</template>

<script>
import organization from "@/assets/data/organization.json";

export default {
    computed: {
        items() {
            return organization.filter((item) => item.site);
        },
    },
    methods: {
        handleSelectChange(selectedValue) {
            if (selectedValue) {
                window.open(selectedValue, "_blank");
            }
        },
    },
};
</script>
